//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "my-workflow",
  data() {
    return {
      refresh:true,
      urlList: ['api/workflowRequestBase/backlog/page',
      'api/workflowRequestBase/through-my/page',
      "api/workflowRequestBase/finished/page",
      "api/workflowMonitor/flowDetail",
      "api/workflow-cc/my/page",
      "api/workflow-forward/my/page",
      "api/workflowRequestBase/my-request/page",
      "api/workflow-supervision/my/page"],
      optionList: [[{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            }], [{
              name: "全部",
              code: null
            },{
              name: "审批中",
              code: '1'
            },{
              name: "归档",
              code: '2'
            }], [{
              name: "全部",
              code: null
            },{
              name: "归档",
              code: '2'
            }], [{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            },{
              name: "归档",
              code: '2'
            }], [], [{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            },{
              name: "归档",
              code: '2'
            }],[{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            },{
              name: "归档",
              code: '2'
            }],[{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            },{
              name: "归档",
              code: '2'
            }]],
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '我的流程',
        url: 'api/workflowRequestBase/backlog/page',
        fixRules: [],
        tabList: ["我的待办","我的已办","我的办结","我监控的","抄送给我的","转发给我的","我的请求","我督办的"],
        inputCondition: {
          placeholder: '流程标题',
          searchCondition: 'key',
          rules: [{
            field: "title",
            option: "LIKE_ANYWHERE"
          }]
        },
        selectConfig:[
          {
            text: '流程状态',
            type: 'selector',
            list: [{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            }],
            rules:[{field:"currentNodeType",option:"IN"}]
          }
        ],
      },
      searchData: {},
      contentList: []
    }
  },
  methods: {
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.contentList = this.contentList.concat(e);
        }else{
          this.contentList = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    conversionName(data, name) {
      let retanData = '';
      if (name) {
        let colName = name.split('.');
        if (data.hasOwnProperty(colName[0])) {
          if (colName.length > 1) {
            for (let i = 0; i < colName.length; i++) {
              if (i == 0) {
                retanData = data[colName[0]];
              } else {
                if (retanData != null) {
                  retanData = retanData[colName[i]];
                } else {
                  return retanData = '';
                }
              }
            }
            return retanData == null ? '' : retanData;
          } else {
            return data[colName[0]] == null ? '' : data[colName[0]];
          }
        } else {
          return retanData == null ? '' : retanData;
        }
      } else {
        return retanData == null ? '' : retanData;
      }
    },
    openFlow(e) {
      let baseUrl;
      if(this.$store.state.systemConfig){
        baseUrl = this.$store.state.systemConfig.systemUrl + '#/';
      }else{
        return;
      }
      this.$router.push('/workflow/'+e.requestId);
    },
    tabChange(param){
      this.config.url = this.urlList[param-1];
      if(param == 6 || param == 8){
        this.config.selectConfig = [
          {
            text: '流程状态',
            type: 'selector',
            list: this.optionList[param-1],
            rules:[{field:"workflowRequestBase.currentNodeType",option:"EQ"}]
          }
        ];
      }else if(param == 5){
        this.config.selectConfig = [
          {
            text: '抄送状态',
            type: 'selector',
            list: [{
              name: "全部",
              code: null
            },{
              name: "待处理 ",
              code: '0'
            }],
            rules:[{field:"handled",option:"EQ"}]
          }
        ];
      }else{
        this.config.selectConfig = [
          {
            text: '流程状态',
            type: 'selector',
            list: this.optionList[param-1],
            rules:[{field:"currentNodeType",option:"IN"}]
          }
        ];
      }
      if(param == 6){
        this.config.inputCondition.rules[0].field = "workflowRequestBase.title"
      }else{
        this.config.inputCondition.rules[0].field = "title"
      }
      console.log(param, this.config.url)
    }
  },
  mounted() {
    let tokens = localStorage.getItem('_token');
    if(tokens){
      this.token = tokens.substr(7);
    }
    setTimeout(() => {
      this.init();
      this.$refs.header.getlist();
    },600);
  }
}



// WEBPACK FOOTER //
// ./src/page/workflow/my-workflow.vue